import axios from "../axios-auth";

export const binService = {
    getBinList,
    saveBin,
    getBinDetail,
    getBinsByStatus,
    getAllBin,
    getNoWarehouseBinList,
    getBinsByWarehouseAndStatus,
};

function getBinList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    return axios.get("/auth/bins", { params });
}

function getNoWarehouseBinList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/nowarehouse-bins", { params });
}

function saveBin(bin) {
    if (!bin.id) {
        // new brand
        return axios.post("/auth/bin", bin);
    } else {
        // edit
        return axios.put("/auth/bin", bin);
    }
}

function getBinDetail(id) {
    return axios.get("/auth/bin/" + id);
}

function getBinsByStatus(status) {
    return axios.get("/auth/bins-by-status/" + status);
}

function getAllBin() {
    return axios.get("/auth/all-bin");
}

function getBinsByWarehouseAndStatus(warehouseId, status) {

    let params = {};

    if (warehouseId) {
        params["warehouseId"] = warehouseId;
    }
    if (status) {
        params["status"] = status;
    }
    return axios.get("/auth/bins-by-warehouse-and-status", { params });
}
